import { render, staticRenderFns } from "./test3-1.vue?vue&type=template&id=5dcd778e&scoped=true"
import script from "./test3-1.vue?vue&type=script&lang=js"
export * from "./test3-1.vue?vue&type=script&lang=js"
import style0 from "./test3-1.vue?vue&type=style&index=0&id=5dcd778e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcd778e",
  null
  
)

export default component.exports